import { PiniaVuePlugin } from 'pinia';
import Vue from 'vue';
import Vuex from 'vuex';
import VueI18n from 'vue-i18n';
import VueRouter from 'vue-router';
import { NamedLink } from './ui/components/navigation/NamedLink';
import BuefyPlugin from './buefy-plugin';
import { createI18nInstance } from '@/ui/i18n/i18n';
import LegacyPlugin from '@/legacy-plugin';
import FullStory from '@/fullstory-plugin';
import VueGtm from 'vue-gtm';
// @ts-ignore
import VueGtag from 'vue-gtag';
import { isProd } from '@/ui/helpers/systemHelper';
import { MazPhoneNumberInput } from 'maz-ui';
// @ts-ignore
import LottieAnimation from 'lottie-web-vue';
import Highcharts from 'highcharts';
import HighchartsVue from 'highcharts-vue';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsOfflineExporting from 'highcharts/modules/offline-exporting';
import HighchartsExportData from 'highcharts/modules/export-data';

HighchartsExporting(Highcharts);
HighchartsOfflineExporting(Highcharts);
HighchartsExportData(Highcharts);

Vue.use(Vuex);
Vue.use(PiniaVuePlugin);
Vue.use(VueRouter);
Vue.use(LegacyPlugin);
Vue.use(VueI18n);
Vue.use(HighchartsVue);
// must create after plugin registration, gives config is undefined error otherwise
createI18nInstance();
Vue.use(BuefyPlugin);
if (isProd) {
  Vue.use(FullStory, { orgId: process.env.VUE_APP_FULL_STORY_ORG_ID });
}
Vue.use(VueGtm, {
  // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  id: process.env.VUE_APP_GTM_KEY,
  // defaults to false. Script can be set to `defer` to increase page-load-time at the cost
  // of less accurate results (in case visitor leaves before script is loaded,
  // which is unlikely but possible)
  defer: false,
  // Whether or not display console logs debugs (optional)
  debug: true,
  // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer
  // functionality in your components) (optional)
  loadScript: true,
  // Whether or not call trackView in Vue.nextTick
  trackOnNextTick: false,
});
Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GTAG_KEY },
});

Vue.component('named-link', NamedLink);
Vue.component('lottie', LottieAnimation);
Vue.use(MazPhoneNumberInput);
